<footer class="footer" *ngIf="showFooter">
  <div class="footer-inner">
    <div class="footer-container">

      <div class="footer-col">
        <h4>Customer Service</h4>
        <a [routerLink]="'/faq'">Help/FAQs</a>
        <a [routerLink]="'/contact-us'">Contact Us</a>
      </div>

      <div class="footer-col">
        <h4>Privacy & Security</h4>

        <a 
          href="https://www.walgreens.com/topic/help/general/noticeprivacypractices.jsp?foot=privacy"
          target="_blank"
          rel="noopener noreferrer">
          Notice of Privacy Practices
        </a>

        <a 
          href="https://www.walgreens.com/topic/help/generalhelp/privacyandsecurity.jsp?foot=security"
          target="_blank"
          rel="noopener noreferrer">
          Online Privacy & Security Policy
        </a>

        <a 
          href="https://www.walgreens.com/topic/help/generalhelp/termsofuse.jsp?foot=terms"
          target="_blank"
          rel="noopener noreferrer">
          Terms & Conditions of Use
        </a>

      </div>

    </div>
  </div>
</footer>